import Icon from '../../../components/AppIcon';

const BizznetRewards = () => {
  const rewardTiers = [
    {
      id: 1,
      icon: "Trophy",
      title: "Sistema de Puntos",
      description: "Gana puntos por cada transacción y referido. Acumula para canjear por descuentos exclusivos o retiro directo.",
      color: "text-yellow-500"
    },
    {
      id: 2,
      icon: "Users",
      title: "Programa de Afiliados",
      description: "Invita a usuarios y negocios. Gana comisiones del 20% (Nivel 1) y 10% (Nivel 2) de sus membresías.",
      color: "text-primary"
    },
    {
      id: 3,
      icon: "Wallet",
      title: "Retiros Flexibles",
      description: "Retira tus ganancias cuando alcances el mínimo de 10,000 puntos. Transferencias directas a tu cuenta.",
      color: "text-green-500"
    }
  ];

  return (
    <section className="py-20 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            BIZZNET Rewards
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Gana puntos, refiere usuarios y obtén ingresos adicionales con nuestro programa de recompensas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {rewardTiers?.map((tier) => (
            <div
              key={tier?.id}
              className="bg-card rounded-2xl p-8 shadow-card hover:shadow-lg transition-all"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center">
                  <Icon name={tier?.icon} size={40} className={tier?.color} />
                </div>
                <h3 className="text-2xl font-bold text-foreground">{tier?.title}</h3>
                <p className="text-muted-foreground leading-relaxed">
                  {tier?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BizznetRewards;